import { Typography } from "@material-ui/core"
import AssociatedEmail from "@root/components/AssociatedEmail"
import AssociatedOpen from "@root/components/AssociatedOpen"
import AssociatedSms from "@root/components/AssociatedSms"
import AssociatedTable from "@root/components/AssociatedTable"
import { useAppDispatch } from "@root/store"
import { selectContactAssociatedChannels } from "@root/store/selectors"
import { associateEmail, associateOpen, associateSms } from "@root/store/thunks"
import {
  AssociatedEmailChannel,
  AssociatedOpenChannel,
  AssociatedSmsChannel,
} from "@root/store/types"
import React from "react"
import { useSelector } from "react-redux"

const Associated: React.FC = () => {
  const dispatch = useAppDispatch()
  const associated = useSelector(selectContactAssociatedChannels)

  const onAssociateEmail = React.useCallback(
    (email: AssociatedEmailChannel) => dispatch(associateEmail(email)),
    [dispatch]
  )

  const onAssociateSms = React.useCallback(
    (sms: AssociatedSmsChannel) => dispatch(associateSms(sms)),
    [dispatch]
  )

  const onAssociateOpen = React.useCallback(
    (open: AssociatedOpenChannel) => dispatch(associateOpen(open)),
    [dispatch]
  )

  return (
    <>
      <AssociatedTable associated={associated} />
      <Typography variant="h6">Associate New</Typography>
      <AssociatedEmail onAssociate={onAssociateEmail} />
      <AssociatedSms onAssociate={onAssociateSms} />
      <AssociatedOpen onAssociate={onAssociateOpen} />
    </>
  )
}

export default Associated
